export const preconclusionStatuses = {
  "Potentially reportable": "Potentially reportable",
  "Not reportable": "Not reportable",
}

export const conclusionErrorStatus = "TemplateConclusionError"
